module.exports = __webpack_public_path__ + "images/products/devices/juul-device-top-half-3c1dc971.png";